import { z } from 'zod';

export const InputSchema = z.object({
    accountId: z.number(),
});

const limitsDetailsObject = z.object({
    url: z.string().url(),
    type: z.enum(['rolling', 'calendar', 'lifetime']),
    windowLengthInDays: z.number(),
    amount: z.number(),
    currency: z.string().length(3),
    used: z.number(),
});

export const SuccessResponseSchema = z.object({
    url: z.string().url(),
    limits: z.array(limitsDetailsObject),
});

export type LimitsDetailsObjectSchemaType = z.infer<typeof limitsDetailsObject>;

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | {
          responseStatus: 'apiError';
          status: number;
          data?: unknown;
      };
